import React from 'react'; 
import './Headless.css'; 

import '../../Button.css'; 

function HeadlessMandarin() {
  window.scrollTo(0, 0);
    return (
      <>
           
          <div className="Headless"> 

          <form method="get" action="#/headless"> 
            <button id="the-button" type='btn'>English</button> 
          </form> 

            <h1 className="exhibition">“沈敬东，蔡江：無頭無心”展覽</h1> 
            <hr /> 

            <img src="./HU1.jpeg" id="image-thing-hu" /> 

            <br /> 

            {/* <h6 id="head-hu">
            “沈敬东，蔡江：無頭無心”展覽 
            </h6>  */} 
            <h5 id="caption">
            日期：2016年9月7日開幕晚
            </h5> 
            <h5 id="caption">
            2016年9月7日至9月30日
            </h5>
            <h5 id="caption">
            展覽：WhiteBox畫廊，紐約布魯姆街329號，紐約10002
            </h5>
            <h5 id="caption">
            合作：策展人劉偉  
            </h5>
            <h5 id="caption">
            藝術家：沈敬东，蔡江 
            </h5> 

            <br /> 

            <img src="./HU2.jpeg" id="image-thing-hu" /> 

            <br /> 

            <h2 id="header-thing-hu">
            策展人劉偉（Lena Liu）說： 
            </h2> 

            <p id="art-paragraph-other">
            2016年9月7日，沈敬東和蔡江的無頭無意識當代藝術展揭幕。在新的藝術表達中，蔡江 遮住了眼睛，用刀切開了沈敬東創作的畫作。
            正義的言行和對殘酷戰爭的反義啟示。最後 ，觀眾用捆綁的照片包裹紗布。這是為了揭示每個人對世界和平與和諧的共同渴望。 
              </p> 
              <p id="art-paragraph-other">
              沈敬東1960年代出生於南京。在1980年代，他深受“ 85新浪潮”的影響。在1990年代從大 學畢業後，他被分配到軍事藝術團從事舞台藝術工作。
              他還從事自己的藝術創作。他於 2004年來到北京。與1960年代出生的大多數中國人一樣，他出生於文化大革命，並在改 革開放中成長。
              他從小就對紅色進行了理想的教育，並擁有18年的軍事經驗，這使他在 今天留下了深刻的烙印和現實。所有這些自然都反映在沉的作品中。 
              </p> 
              <p id="art-paragraph-other">
              相比之下，蔡江在中國哲學中“無所作為”的普遍哲學體現了它的隨機性，不可預測性和自 然的生活智慧。他的畫作不僅遮住了眼睛，向內看，
              而且還創造了當代藝術，例如雨，頭 髮，火山和地震。同時，觀眾將閉上眼睛，體驗表演帶來的複活，恢復和康復的過程。在 這種形式下，
              “黃色皇帝內部經典”的行為康復和阿根廷/意大利藝術家盧西奧·豐塔納的“分 居”，是日本傳奇表演團體古泰藝術協會之後的新發展，
              為當代盲人康復創造了一條道路 。從未見過的 
              </p> 
              <p id="art-paragraph-other">
              沈敬東和蔡江共同完成瞭如此精彩的當代藝術展覽，使他們的作品可以相互聯繫，交織， 深刻，卻彼此相對。沈敬東與蔡江一起塑造了華麗，
              積極的軍事形象。這是強烈的反差力 量。這具有深遠的意義，就像當今世界的起伏一樣，相互作用中的陰陽也會發生變化。 
              </p> 

              <img id="image-thing" src="HU3.jpeg" /> 

              <br /> 

              <h2 id="header-thing-hu">
              關於藝術家：  
            </h2> 

            <p id="art-paragraph-other">
            沈敬東，男，1965年出生，現在在北京生活和工作。 1984年從南京蕭莊師範學校畢業後 ，他就讀於南京藝術學院美術系，並於1991年畢業。同年，
            他被分配到南京軍區前線話 劇團上舞台。藝術。這種軍事背景激發了沈氏的藝術風格，圖像和卡通風格的軍事肖像。 
            他使用陶瓷雕塑和繪畫不斷探索英雄和波普藝術的主題。他的作品曾在美國，歐洲和中國 展出。最近的展覽包括：2015年，
            “Censure”，法國DOCK SUD畫廊。 2014年，巴黎藝 術博覽會，中法建交50週年（la Chine a l'honneur）。 2010年和2012年，“視覺藝術， 
            東西劍”，美國巡迴演唱會。 
              </p> 
              <p id="art-paragraph-other">
              蔡江原名蔡建華，來自中國四川。 1979年，他前往美國當代藝術之地紐約。 37年來 ，他一直在培養和理解中國哲學的超感官，
              超經驗和過時的“道德經驗”。將中醫與切，陰 ，陽，“皇帝內經”的身體，精神和靈魂相結合。自1981年以來，他在美國舉辦了30多次 
              個人藝術展覽，並參加了20多次展覽。他由六家美國畫廊和經紀公司，一家英國畫廊和 一家中國經紀公司代理並晉升。他參加了世界各地的藝術博覽會。 
              2014年，他在紐約市 皇后博物館（Queen's Museum）進行了為期四天的盲文藝術表演，題為“藝術診斷與藝 術診斷”。從2015年到2016年，
              他在紐約市WhiteBox藝術中心進行了盲人表演和個展。 2016年，他在重慶長江當代美術館和北京美術館舉辦了個展。他的作品已被喬治·布 
              什總統以及許多藝術機構和個人收藏。 
              </p> 

          </div>
        </> 
    );
  }
  
  export default HeadlessMandarin; 